import { Container } from '@loomhq/lens';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import SVGInline from 'react-svg-inline';

import PlayScreenSpeedSelector from './play-screen-speed-selector';
import ReactionsTimeline from './play-screen-timeline';
import { EmbedContext } from '../../embed-video';
import { useIosSafariRotatedMedia } from '../../../hooks/useIosSafariRotatedMedia';
import { secondsToHumanReadableString } from '../../../../../shared/utilities/time';

import LoadingSpinner from 'components/ui-components/circular-loading-spinner';

import './styles.less';

const BIG_PLAY_BUTTON_SVG = `
<svg viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path opacity="0.3" d="M45 90C69.8529 90 90 69.8527 90 44.9999C90 20.1471 69.8529 0 45 0C20.1472 0 0 20.1471 0 44.9999C0 69.8527 20.1472 90 45 90Z"/>
  <path d="M45 85C67.0914 85 85 67.0913 85 44.9999C85 22.9086 67.0914 5 45 5C22.9086 5 5 22.9086 5 44.9999C5 67.0913 22.9086 85 45 85Z"/>
  <g opacity="0.6">
    <path d="M35 33.268V56.732C35 58.5212 37.0582 59.6083 38.6432 58.6344L57.8999 46.9025C59.3667 46.0192 59.3667 43.9808 57.8999 43.0749L38.6432 31.3656C37.0582 30.3917 35 31.4788 35 33.268Z" fill="#212121"/>
  </g>
</svg>
`;

const PlayScreen = props => {
  const {
    EditVideoButtons,
    ViewerVideoButtons,
    fullScreen,
    isLoading,
    onPlay,
    duration,
    theaterMode,
    isMainVideoOnSharePage,
  } = props;

  const [areVideoButtonsShown, setAreVideoButtonsShown] = useState(false);

  useEffect(() => {
    // short wait before rendering the edit buttons to avoid janky animation
    const timeout = setTimeout(() => {
      setAreVideoButtonsShown(true);
    }, 500);

    return () => {
      // in case the timeout has not executed yet, cancel it
      clearTimeout(timeout);
    };
  }, []);

  const {
    isIosRotatedMedia,
    sourceUrlIsTranscoded,
  } = useIosSafariRotatedMedia();

  if (isIosRotatedMedia && !sourceUrlIsTranscoded) {
    return null;
  }

  const drawPreplayDuration = isMainVideoOnSharePage;

  return (
    <EmbedContext.Consumer>
      {({ hideSpeedSelector }) => (
        <div
          className={classNames(
            'video-player-play-screen',
            isLoading && 'is-loading',
            (theaterMode || fullScreen) && 'large-format'
          )}
          onClick={() => onPlay?.()}
        >
          <div className="button-container">
            <div className="big-play-button">
              {!isLoading && <SVGInline svg={String(BIG_PLAY_BUTTON_SVG)} />}
              {isLoading && (
                <LoadingSpinner color="var(--brandThemedBigPlayButtonIconColor, black)" />
              )}
            </div>
            <div className="relative-el">
              {!hideSpeedSelector && <PlayScreenSpeedSelector />}
              {drawPreplayDuration && duration > 0 && (
                <p className="play-screen-duration">
                  <Container
                    radius="medium"
                    paddingY="xsmall"
                    paddingX="small"
                    backgroundColor="var(--videoOverlay)"
                    htmlTag="span"
                  >
                    {secondsToHumanReadableString(duration)}
                  </Container>
                </p>
              )}
            </div>
          </div>
          <ReactionsTimeline suppressActiveBubble={true} />
          {EditVideoButtons && areVideoButtonsShown && (
            <div className="edit-video-buttons absolute right:0 text:right">
              <EditVideoButtons startCollapsed />
            </div>
          )}
          {ViewerVideoButtons && areVideoButtonsShown && (
            <div className={'viewer-video-buttons absolute right:0 text:right'}>
              <ViewerVideoButtons startCollapsed />
            </div>
          )}
        </div>
      )}
    </EmbedContext.Consumer>
  );
};

export default PlayScreen;
